import React from "react";
import DataGrid from "../../../../../dataGrid";
import GridConfig from "./GridConfig";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import StatusBar from "../../../../../dataGrid/StatusBar";

class ReturnShipmentGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
  }

  constructStatusBar = (filteredData) => {
    const statusBarData = [
      {
        label: filteredData.length + " Returns",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  render() {
    const {
      returnShipments = [],
      classes,
      quickFilterText,
      showLoader,
    } = this.props;

    return (
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowData={showLoader ? null : returnShipments}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
            />
          )}
          quickFilterText={quickFilterText}
          showErrorMessage={this.props.gridErrorMessage}
        />
      </div>
    );
  }
}
export default compose(withSnackbar, withStyles(styles))(ReturnShipmentGrid);
